import { Injectable } from '@angular/core'
import { TranslateService } from '@ngx-translate/core'
import { UserStorageService } from 'common/util/services/sharedStorage.service'
import { IdentityService } from 'main/services/identity.service'
import { ShowInExplorerService } from 'media/services/showInExplorer.service'
import { PanelService } from 'panel/services/panel.service'
import { MediaOperationsService } from '../services/mediaOperations.service'
import { BaseOperation } from './base'

@Injectable({ providedIn: 'root' })
class OpenLocallyOp extends BaseOperation {
  icon = 'far fa-window-restore'
  showInOverflowMenu = true
  showInContextMenu = true
  showInAssetView = true
  supportsDirs = true
  supportsBundles = true
  weight = 101

  constructor (
    private showInExplorer: ShowInExplorerService,
    private translate: TranslateService,
    private identity: IdentityService,
    private panel: PanelService,
    private userStorage: UserStorageService,
  ) {
    super()
    this.label = translate.instant('Open locally')
  }

  isVisibleFor () {
    return !this.identity.user?.isExternal
  }

  getLabelForBundle (bundle) {
    return this.showInExplorer.getOpenLabel(bundle)
  }

  isEnabledForDir (dir) {
    return dir.present && this.identity.hasPermission('client:access') && !this.panel.active
  }

  isEnabledForBundle (bundle) {
    return bundle?.mainfile?.present && this.identity.hasPermission('client:access') && !this.panel.active
  }

  async runForDir (dir) {
    this.showInExplorer.openFile(dir)
  }

  async runForBundle (bundle, context) {
    this.showInExplorer.openBundle(bundle)
    const { name } = bundle.mainfile
    const ext = name.substring(name.lastIndexOf('.')).toLowerCase()
    if (context.root && ['.prproj', '.fcpxml', '.aep', '.avp'].includes(ext)) {
      let recentProjects = this.userStorage.get('recent-editor-projects', [])
      recentProjects = recentProjects.filter(x => x.file !== bundle.mainfile.id)
      recentProjects = [{ file: bundle.mainfile.id, root: context.root.id }, ...recentProjects.slice(0, 5)]
      this.userStorage.querySet('recent-editor-projects', recentProjects)
    }
  }
}

MediaOperationsService.register(OpenLocallyOp)
